<div class="wrapper">
    <header class="header navbar navbar-expand-md row">
        <h2 class="col col-sm-7">RTO Exam Preparation</h2>
        <div class="row col col-sm-5">
            <div class="login-btn col col-sm-6">
                <a href="index.html"><button class="btn-fill"><p>HOME</p></button></a>
            </div>            
            <div class="login-btn col col-sm-6">
                <a href="login.html"><button class="btn-fill"><p>LOGIN</p></button></a>
            </div>
        </div>        
    </header>
    <section class="container">
    <!-- <div class="wrapper"> -->
        <div class="instruction">
            <h3>Instruction:</h3>
            <p>You have selected {{ questioncnt }} Question.</p>
            <p>You have 45sec. For each Question.</p>
            <div class="chagequearea">
                <p cl>Change Questions Count : </p><input type="number" [(ngModel)]='varcnt'/> 
                <button (click)="changeQuecount()">Change</button>
            </div>                
        </div>
        <div class="question">
            <div class="que-main-head row">
                <div class="time-icon  col col-sm-2 col-xl-2 col-12">
                    <div *ngFor="let i of dummy">
                        <circle-progress
                            [percent]="tsec1"
                            [title]="ptime"
                        ></circle-progress>
                    </div>
                </div>                 
               
                <div class="que-head col col-sm-10 col-xl-10 col-12">
                    <h1>Total Question {{ questioncnt }}:</h1>
                </div>
            </div>
            <div class="option-area">
            <!-- <form action="submitted.html"> -->
                <div class="que">            
                    <div *ngIf="ques?.length > 0; else  quefail"> 
                        <div *ngFor="let q of ques; let j = index">
                            <div [(ngModel)]="selected" name="option" ngDefaultControl>
                                <h3 style="font-size: 23px;">{{ j+1 }}. {{ q.que }}</h3>
                                <div *ngIf="q.hasImg">                
                                    <img src="../../../assets/QueImg/{{ q.imgurl }}">                            
                                </div>
                                <div *ngFor="let option of [q.op1,q.op2,q.op3]">
                                    <div class="option">
                                        <!-- <input id="{{i}}" type="checkbox" [(ngModel)]="i.Selected" (change)="onSelect(q, i);" /> -->
                                        <input type="radio" value="{{ option }}" name="{{ j }}" (change)="onSelect(j,$event)">
                                        <p>{{ option }}</p>
                                    </div>                                        
                                </div>
                            </div>
                        </div>
                        <button type="submit" id="submitbtn" class="btn-fill" (click)="AnswerQuestion()">Submit</button>
                    </div>
                    <ng-template #quefail>
                        <p>If Question is not available Restart it.</p>
                        <button type="submit" id="submitbtn" class="btn-fill" (click)="Restartonfail()">Restart</button>
                    </ng-template>
                    
                </div>                                                               
            </div>  
            <!-- </form> -->
        </div>        
    <!-- </div> -->
</section>
<footer class="footer">
    <h5>coyright &copy; 2020,MS-creation</h5>
</footer>
</div>